import { fmtDate, money } from "@/components/common";

export function drawPurchaseOrder(doc, po) {
  let y = 20;
  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.text("Heliopolis Pharmaceuticals", 20, y);
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("ops@heliopolispharmaceuticals.com", 20, (y += 6));
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(`PURCHASE ORDER ${po.po_number || po.number}`, 20, (y += 16));
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`Supplier: ${po.supplier_name || "—"}`, 20, (y += 7));
  if (po.supplier?.email) doc.text(`Email: ${po.supplier.email}`, 20, (y += 6));
  if (po.supplier?.country) doc.text(`Country: ${po.supplier.country}`, 20, (y += 6));
  if (po.order_number) doc.text(`Client order: ${po.order_number}`, 20, (y += 6));
  doc.text(`Expected: ${fmtDate(po.expected_date)}`, 20, (y += 6));
  doc.text(`Status: ${String(po.status || "").toUpperCase()}`, 20, (y += 6));
  y += 10;
  doc.setFont("helvetica", "bold");
  doc.text("Product", 20, y); doc.text("Qty", 120, y); doc.text("Cost", 145, y); doc.text("Amount", 175, y);
  doc.line(20, y + 2, 195, y + 2);
  doc.setFont("helvetica", "normal");
  y += 8;
  (po.items || []).forEach((it) => {
    if (y > 270) { doc.addPage(); y = 20; }
    doc.text(String(it.name).slice(0, 50), 20, y);
    doc.text(String(it.quantity), 120, y);
    doc.text(money(it.unit_price), 145, y);
    doc.text(money(it.quantity * it.unit_price), 175, y);
    y += 7;
  });
  doc.line(20, y, 195, y);
  y += 8;
  doc.setFont("helvetica", "bold");
  doc.text("Total", 145, y); doc.text(money(po.total), 175, y);
  if (po.notes) { y += 12; doc.setFont("helvetica", "normal"); doc.text(doc.splitTextToSize(`Notes: ${po.notes}`, 175), 20, y); }
}
